module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }